import { isPlainObject } from 'modules/post-message'

import { PLAYER_JS_CONTEXT, PLAYER_JS_VERSION } from './constants'
import { PlayerJsRequest } from './types'

export const parseRequest = ({ data }: { data: unknown }): PlayerJsRequest | null => {
    let parsed: unknown = data

    if (typeof data === 'string') {
        try {
            parsed = JSON.parse(data)
        } catch {
            return null
        }
    }

    if (!isPlainObject(parsed)) return null
    if (parsed.context !== PLAYER_JS_CONTEXT) return null
    if (typeof parsed.method !== 'string' || parsed.method.length === 0) return null

    return {
        context: PLAYER_JS_CONTEXT,
        version: typeof parsed.version === 'string' ? parsed.version : undefined,
        method: parsed.method,
        value: parsed.value,
        listener: typeof parsed.listener === 'string' ? parsed.listener : undefined,
    }
}

type SerializeProps = {
    event: string
    value?: unknown
    listener?: string
}

export const serializeResponse = ({ event, value, listener }: SerializeProps): string => {
    const payload: Record<string, unknown> = {
        context: PLAYER_JS_CONTEXT,
        version: PLAYER_JS_VERSION,
        event,
    }

    if (value !== undefined) payload.value = value
    if (listener) payload.listener = listener

    return JSON.stringify(payload)
}
